export const ordinalSuffix = (number: number) => {
  const remainder = number % 100;

  if (remainder < 10 || remainder > 20) {
    switch (remainder % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};
